import { isNil } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import PopUp from '../../components/PopUp.jsx';

const el = document.querySelector('.newsletter-popup-container');
if (!isNil(el)) {
    ReactDOM.render(<PopUp />, el);
}
